import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { RepairModeSearchTextForm } from '../../../form-model/repair-mode-search-text.form.model';
import '@maersk-global/mds-components-core/mc-input';

@Component({
  selector: 'app-repair-mode-search',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './repair-mode-search.component.html',
  styleUrl: './repair-mode-search.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RepairModeSearchComponent implements OnInit {
  @Input({ required: true }) repairModeSearchTextForm!: FormGroup<RepairModeSearchTextForm>;

  constructor(private readonly formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.addControlsToTheFormGroup();
  }

  applySearchTextFilters(): void {
    this.repairModeSearchTextForm.controls.appliedRepairModeSearchTextFilter.setValue(true);
  }

  isControlInErrorState(control: FormControl): boolean | null {
    return control.invalid && control.touched ? true : null;
  }

  private addControlsToTheFormGroup(): void {
    this.repairModeSearchTextForm.addControl('SearchText', this.formBuilder.control<string | null>(null));
    this.repairModeSearchTextForm.addControl(
      'appliedRepairModeSearchTextFilter',
      this.formBuilder.control<boolean | null>(null),
    );
  }
}
